import { useState, useEffect, useRef } from "react";
import moment from 'moment';
import { fieldDateFormat } from '../../../constants';
import { enqueueSnackbar } from "notistack";
import { useNavigate, useParams } from 'react-router-dom';
import { Table, TableBody, TableSortLabel, Paper, Button, TableRow, TableHead, TableCell, MenuItem, Grid, Box, Checkbox } from "@mui/material";
import { LeasesMenuList, LeasesNav, LeasesBasicDetails } from '../../elements';
import { DeletePopUp, FilterComponent, jetStreamInstance, PageLoader, Pagination, PopOverCTA, STableLoader, titanAviationIntance, hanwahaInstance, gaTelesisInstance } from '../../../shared_elements';
import { checkApiStatus, getGlobalCookie } from "../../../utils";
import { ChangeInvoiceStatus, InvoiceList, BulkChangeInvoiceStatus, BulkSendMailModal, RevertInvoiceStatus, BulkDeleteInvoiceModal } from "../components";
import NoRecordFound from "../../../shared_elements/NoRecordFound";
import { globalDeleteService, globalGetService } from "../../../utils/globalApiServices";
import { deleteInvoiceApi, getInvoiceAuthUrl, getInvoicesApi } from "../apiService";
import { getQbStatusApi } from "../../quickBooks/apiService";
import { setGlobalCookie } from "../../../utils";
import { addInvoiceObj, getManagementFeeSelectDisabledReason } from "..";
import { ButtonLoader, ShowAttachments } from "../../../shared_elements/components";
import AddRentalInv from "../components/AddRentalInv";
import AddAdhocInv from "../components/AddAdhocInv";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { isMobile } from "react-device-detect";
import { trackActivity } from "../../../utils/mixpanel";
import { RoleBaseAccess } from "../../../hoc";
import { PermissionWrapper } from "../../../wrappers";
import { getCurrencyAc, getStorage } from "../../../shared_elements/actionCreators";
import { useDispatch, useSelector } from "react-redux";
import ModuleNotExcessModal from "../../../shared_elements/components/ModuleNotExcessModal";
import LeaseInvHeaderCards from "../components/leaseInvHeaderCard";
import ModuleWiseRevisionHistory from "../../../shared_elements/components/ModuleWiseRevisionHistory";
import RevisionHistory from "../../../shared_elements/components/RevisionHistory";
import BackToLeaseList from "../../elements/BackToLeaseList";
import ExportFileTypeComp from "../../../shared_elements/components/ExportFileTypeComp";
import AddLeaseCreditDebitNote from "../components/AddLeaseCreditDebitNote";
import UploadAttachmentsModal from "../components/InvUploadAttachmentsModal";
import FileUploadLayout from "../../../shared_elements/components/FileUploadLayout";
import { getApiResponse } from "../../../utils/fileUpload";

const invoiceStatusOptions = [
    { label: 'Draft', value: 1 },
    { label: 'Sent', value: 2 },
    { label: 'Paid', value: 3 },
    { label: 'Cancelled', value: 4 },
    { label: 'Partially-Paid', value: 5 },
    ...(jetStreamInstance ? [{ label: 'Updated', value: 6 }] : []),
    ...(titanAviationIntance ? [{ label: 'Approved', value: 7 }] : []),
];
const mrPendingApprovalStageOptions =
    [{ label: 'Finance Control', value: 1 },
    { label: 'Accounting Control', value: 2 },
    { label: 'Final Control', value: 3 }]
;

const invoiceTypeOptions = [
    { label: 'Reserve', value: 1 },
    { label: 'Rental', value: 2 },
    { label: 'Penalty', value: 3 },
    { label: 'Debit', value: 4 },
    { label: 'Credit', value: 5 },
    { label: 'Adhoc', value: 9 },
    { label: 'Security Deposit', value: 6 },
    { label: 'Management Fee', value: 10 },
];

const invoiceSubTypeOptions = [
    { label: 'Advanced', value: '1' },
    { label: 'Arrears', value: '2' },
];

const dateRangeFilterFields = [
    { key: 'invoice_start_date', label: 'Invoice Date (Start Range)' },
    { key: 'invoice_end_date', label: 'Invoice Date (End Range)' },
    { key: 'due_start_date', label: 'Due Date (Start Range)' },
    { key: 'due_end_date', label: 'Due Date (End Range)' },
    { key: 'start_date', label: 'Period Start Date' },
    { key: 'end_date', label: 'Period End Date' },
    { key: 'payment_start_date', label: 'Payment Start Date' },
    { key: 'payment_end_date', label: 'Payment End Date' },
];

const InvoiceHd = ({ bulkFlag, sortInfo, onChangeBulkOps, createSortHandler, selectedCount, selectableCount, onSelectAll, hasAnySelection }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Lease Invoices`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )
    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ minWidth: isMobile ? '110px' : '90px', whiteSpace: "nowrap" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['D'] }}>
                            <Checkbox
                                size="small"
                                // indeterminate={selectedCount > 0 && selectedCount < selectableCount}
                                checked={selectableCount > 0 && selectedCount === selectableCount}
                                disabled={!hasAnySelection || selectableCount === 0}
                                onChange={onSelectAll}
                            />
                        </PermissionWrapper>
                        Action(s)
                    </Box>
                </TableCell>
                <TableCell sx={{ minWidth: '145px' }}> {tableSorting('invoice_number', 'Invoice Number')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('date', 'Invoice Date')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('due_date', 'Due Date')}</TableCell>
                <TableCell sx={{ minWidth: '155px' }}> {tableSorting('period', 'Invoice Period')}</TableCell>
                <TableCell sx={{ minWidth: '135px' }}> {tableSorting('status', 'Status')}</TableCell>
                <TableCell sx={{ minWidth: '145px' }}> {tableSorting('amount', 'Amount')}</TableCell>
            </TableRow>
        </TableHead>
    )
}

const LeaseInvoices = () => {
	const {  currencies } = useSelector((state) => state.leases);
    const navigate = useNavigate()
    const dispatch= useDispatch();
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const headerCardRef = useRef(null);
    const [isLoading, setLoading] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: 'desc', sort_by: gaTelesisInstance ? 'period' : 'date' });
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [addEditInvoice, setAddEditInvoice] = useState({ mode: '', modal: false, data: null, type: '' })
    const [addCreditDebitNote, setAddCreditDebitNote] = useState({ mode: '', modal: false, data: null, type: '' })
    const [addRentalInvoice, setAddRentalInvoice] = useState({ mode: '', modal: false, data: null, type: '' })
    const [deleteInvoices, setDeleteInvoices] = useState({ modal: false, item: {}, data: { ids: [] } })
    const [invoicesInfo, setInvoicesInfo] = useState({ list: [], pagination: null });
    const [isExport,setIsExport]=useState(false)
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const [changeInvStatus,setChangeInvStatus]=useState({ modal: false, data: null });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [filter, setFilter] = useState({});
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [bulkChangeStatus, setBulkChangeStatus] = useState({ modal: false });
    const [bulkDeleteInvoices, setBulkDeleteInvoices] = useState({ modal: false });
    const [bulkSendMail, setBulkSendMail] = useState({ modal: false });
    const [isQbEnabled, setIsQbEnabled] = useState(false);
    const [revertStatusInv, setRevertStatusInv] = useState({ modal: false, data: null });
    const [uploadAttachments, setUploadAttachments] = useState({ modal: false, data: null });
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const[uploadFileProgressData,setUploadFileProgressData]=useState({});
    const [slug,setSlug]=useState({});

    const firstSelectedStatus = selectedInvoices.length > 0 ? selectedInvoices[0].status?.value : null;

    const canBulkSend = selectedInvoices.length > 0 && selectedInvoices.every(inv => inv?.status?.value === 2);

    const canBulkDelete = selectedInvoices.length > 0 && selectedInvoices.every(inv => inv?.status?.value === 1);

    // Multi Approval Flow (Titan) has no single approval_decision - "approved" only once every control stage is approved (item.approval_status), unlike the single-decision approval_decision.status used for the older flow.
    const isInvoiceApprovalPending = (item) => {
        const isMultiApprovalInvoice = titanAviationIntance && item?.is_invoice_approval && item?.invoice_type?.value !== 10 && (item?.invoice_type?.value === 1 || item?.parent_id);
        return isMultiApprovalInvoice ? item?.approval_status !== 'approved' : item?.approval_decision?.status !== 2;
    };

    const canSelectInvoice = (item) => {
        if (item?.qb_last_sync_by) return false;
        if (item?.is_summary_linked === true) return false;
        if (item?.is_invoice_approval && item?.invoice_type?.value !== 10 && !!item?.lease_slug && isInvoiceApprovalPending(item) && item?.status?.value === 1) return false;
        if (item?.status?.value === 2 && item?.bulk_selectable === false) return false;
        if (![1, 2].includes(item?.status?.value)) return false;
        if (item?.status?.value === 1 && item?.date && moment(item.date).isAfter(moment(), 'day')) return false;
        if (firstSelectedStatus !== null && item.status.value !== firstSelectedStatus) return false;
        if (getManagementFeeSelectDisabledReason(item, selectedInvoices)) return false;
        return true;
    };

    const getSelectDisabledReason = (item) => {
        if (item?.qb_last_sync_by && item?.is_summary_linked === true)
			return 'This invoice is linked with a Summary Invoice and is synced to QuickBooks, so this cannot be selected.';
        if (item?.qb_last_sync_by)
            return 'This invoice is synced to QuickBooks and cannot be selected.';
        if (item?.is_summary_linked === true)
			return 'This invoice is linked with a Summary Invoice and cannot be selected.';
        if (item?.is_invoice_approval && item?.invoice_type?.value !== 10 && !!item?.lease_slug && isInvoiceApprovalPending(item) && item?.status?.value === 1)
            return 'This invoice is not approved yet. Bulk status change is not available.';
        if (item?.status?.value === 1 && item?.date && moment(item.date).isAfter(moment(), 'day'))
            return `Invoice Date (${moment(item.date).format(fieldDateFormat)}) is in the future. Bulk status change is not available for this invoice.`;
        return getManagementFeeSelectDisabledReason(item, selectedInvoices);
    };

    const selectableInCurrentPage = invoicesInfo?.list?.filter(canSelectInvoice) || [];
    const selectedInCurrentPage = selectableInCurrentPage.filter(inv => selectedInvoices.some(s => s.slug === inv.slug));

    const onToggleSelectInvoice = (item) => {
        setSelectedInvoices(prev => {
            const alreadySelected = prev.some(inv => inv.slug === item.slug);
            return alreadySelected ? prev.filter(inv => inv.slug !== item.slug) : [...prev, item];
        });
    };

    const onSelectAll = () => {
        if (selectedInCurrentPage.length === selectableInCurrentPage.length) {
            setSelectedInvoices(prev => prev.filter(inv => !selectableInCurrentPage.some(s => s.slug === inv.slug)));
        } else {
            const toAdd = selectableInCurrentPage.filter(inv => !selectedInvoices.some(s => s.slug === inv.slug));
            setSelectedInvoices(prev => [...prev, ...toAdd]);
        }
    };

	const invoiceFilterMenu = {
		invoice_number: { title: 'Invoice Number', inputType: 'text' },
		invoice_type: { title: 'Invoice Type', inputType: 'dropdown', options: invoiceTypeOptions, valueKey: 'value', labelKey: 'label', multiple: true },
		sub_type: { title: 'Sub-Type', inputType: 'dropdown', options: invoiceSubTypeOptions, valueKey: 'value', labelKey: 'label', multiple: true },
		status: { title: 'Status', inputType: 'dropdown', options: invoiceStatusOptions, valueKey: 'value', labelKey: 'label', multiple: true },
		invoice_start_date: { title: 'Invoice Date (Start Range)', inputType: 'date' },
		invoice_end_date: { title: 'Invoice Date (End Range)', inputType: 'date' },
		due_start_date: { title: 'Due Date (Start Range)', inputType: 'date' },
		due_end_date: { title: 'Due Date (End Range)', inputType: 'date' },
		start_date: { title: 'Period Start Date', inputType: 'date' },
        end_date: { title: 'Period End Date', inputType: 'date' },
        payment_start_date: {title: 'Payment Start Date', inputType: 'date'},
		payment_end_date: {title: 'Payment End Date', inputType: 'date'},
		currency: { title: 'Currency', inputType: 'dropdown', options: currencies || [], valueKey: 'code', labelKey: 'name', multiple: true, },
		...(titanAviationIntance ? {
			mr_approval_status_finance: {
				inputType: 'dropdown',
				placeholder: 'Select MR Approval Status (Finance)',
				options: [{ label: 'Approved', value: 2 }],
				title: 'MR Approval Status (Finance)',
				labelKey: 'label',
				valueKey: 'value',
				dependentFields: ['mr_pending_approval_by'],
				disabledWhen: (filterOption) => !!filterOption?.mr_pending_approval_by,
			},
			mr_approval_status_accounting: {
				inputType: 'dropdown',
				placeholder: 'Select MR Approval Status (Accounting)',
				options: [{ label: 'Approved', value: 2 }, { label: 'Rejected', value: 3 }],
				title: 'MR Approval Status (Accounting)',
				labelKey: 'label',
				valueKey: 'value',
				dependentFields: ['mr_pending_approval_by'],
				disabledWhen: (filterOption) => !!filterOption?.mr_pending_approval_by,
			},
			mr_approval_status_final: {
				inputType: 'dropdown',
				placeholder: 'Select MR Approval Status (Final)',
				options: [{ label: 'Approved', value: 2 }, { label: 'Rejected', value: 3}],
				title: 'MR Approval Status (Final)',
				labelKey: 'label',
				valueKey: 'value',
				dependentFields: ['mr_pending_approval_by'],
				disabledWhen: (filterOption) => !!filterOption?.mr_pending_approval_by,
			},
			mr_pending_approval_by: {
				title: 'MR Invoice Pending Approval By',
				inputType: 'dropdown',
				options: mrPendingApprovalStageOptions || [],
				valueKey: 'value',
				labelKey: 'label',
				dependentFields: ['mr_approval_status_finance', 'mr_approval_status_accounting', 'mr_approval_status_final'],
				disabledWhen: (filterOption) => !!(filterOption?.mr_approval_status_finance || filterOption?.mr_approval_status_accounting || filterOption?.mr_approval_status_final),
			},
		} : {}),
	};

    useEffect(() => {
        trackActivity('Page Viewed',{ page_title: 'Lease Invoices'});
        globalGetService(getQbStatusApi()).then(response => {
            if (checkApiStatus(response)) setIsQbEnabled(response.data.data?.is_lessor_enabled || false);
        });
    }, []);

    useEffect(() => {
        if (!leaseBasicDetails) return;
        if (leaseBasicDetails?.status === "Draft") return;
        getInvoices('skeletonLoader', { per_page: 50, lease_slug: params?.leaseSlug, sort_by: sortInfo.sort_by, sort: sortInfo.sort });
        dispatch(getCurrencyAc({}));
    }, [leaseBasicDetails?.status]);

    const getInvoices = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getInvoicesApi(params, query), {}).then(response => {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            if (checkApiStatus(response)) {
                setInvoicesInfo(response?.data?.data)
            }
        });
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"invoices"}));
    }

    const onDeleteInvoice = () => {
        setLoading(true);
        globalDeleteService(deleteInvoiceApi(params), { ids: [deleteInvoices?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Lease Invoice`, success_msg: response?.data?.message, item_ids: deleteInvoices?.data, response: response?.data })
                    setDeleteInvoices({ modal: false, data: null });
                    setLoading(false);
                    getInvoices('', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug });
                    headerCardRef.current?.refresh();
                    setSelectedInvoices([]);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Lease Invoice`, error_msg: response?.data?.message, item_ids: deleteInvoices?.data, response: response?.data })
                }
            })
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key }
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        setSelectedInvoices([]);
        getInvoices('', {
            ...filter,
            ...sortQuery,
            page: invoicesInfo?.pagination?.current_page || 1,
            per_page: invoicesInfo?.pagination?.per_page || 50,
            lease_slug: params?.leaseSlug
        });
    }

    const onDeteAttchments = (deltedslug) => {
        if (addEditInvoice?.modal) {
            setAddEditInvoice({
                ...addEditInvoice,
                data: {
                    ...addEditInvoice.data,
                    attachments: addEditInvoice.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        if (addCreditDebitNote?.modal) {
            setAddCreditDebitNote({
                ...addCreditDebitNote,
                data: {
                    ...addCreditDebitNote.data,
                    attachments: addCreditDebitNote.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getInvoices('', { page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug });
    }

    const handleExport = (fileType) => {
        let query = { lease_slug: leaseSlug, export: true, file_type: fileType, ...filter }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = { ...query, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by }
        }
        setIsExport(true);
        globalGetService(getInvoicesApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                setIsExport(false);
            }
        })
    }
    const onApplyFilter = (query) => {
        if (query.start_date && query.end_date && moment(query.start_date).isAfter(moment(query.end_date), 'day')) {
            enqueueSnackbar('Period Start Date must be before End Date', { variant: 'error' });
            return false;
        }
        if (query.invoice_start_date && query.invoice_end_date && moment(query.invoice_start_date).isAfter(moment(query.invoice_end_date), 'day')) {
            enqueueSnackbar('Invoice Date Start Range must be before End Range', { variant: 'error' });
            return false;
        }
        if (query.due_start_date && query.due_end_date && moment(query.due_start_date).isAfter(moment(query.due_end_date), 'day')) {
            enqueueSnackbar('Due Date Start Range must be before End Range', { variant: 'error' });
            return false;
        }
        if (query.invoice_start_date && query.due_start_date && moment(query.due_start_date).isBefore(moment(query.invoice_start_date), 'day')) {
            enqueueSnackbar('Due Date Start Range cannot be before Invoice Date Start Range', { variant: 'error' });
            return false;
        }
        if (query.invoice_start_date && query.due_end_date && moment(query.due_end_date).isBefore(moment(query.invoice_start_date), 'day')) {
            enqueueSnackbar('Due Date End Range cannot be before Invoice Date Start Range', { variant: 'error' });
            return false;
        }
        if (query.payment_start_date && query.payment_end_date && moment(query.payment_start_date).isAfter(moment(query.payment_end_date), 'day')) {
            enqueueSnackbar('Payment Start Date must be before Payment End Date', { variant: 'error' });
            return false;
        }
        for (const field of dateRangeFilterFields) {
            const value = query[field.key];
            if (!value) continue;
            if (leaseBasicDetails?.start_date && moment(value).isBefore(moment(leaseBasicDetails.start_date), 'day')) {
                enqueueSnackbar(`${field.label} cannot be before Lease Start Date`, { variant: 'error' });
                return false;
            }
            if (leaseBasicDetails?.end_date && moment(value).isAfter(moment(leaseBasicDetails.end_date), 'day')) {
                enqueueSnackbar(`${field.label} cannot be after Lease End Date`, { variant: 'error' });
                return false;
            }
        }
        setFilter(query);
        setSelectedInvoices([]);
        getInvoices('', { ...query, page: 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug });
    }
    const isQbSyncEligibleInvoice = (inv) => [1, 2].includes(inv?.invoice_type?.value) || (hanwahaInstance && ([1, 2].includes(inv?.child_invoice_type) || [1, 2].includes(inv?.linked_invoice_type) || [4, 5, 6, 9].includes(inv?.invoice_type?.value)));
    const sentInvoicesForSync = selectedInvoices.filter(inv => inv?.status?.value === 2 && inv?.id != null && isQbSyncEligibleInvoice(inv) && !inv?.is_summary_linked && !inv?.qb_last_sync_by).slice(0, 50);

    const syncInvoicesToQb = () => {
        const invoiceIds = sentInvoicesForSync.map(inv => inv.id).join(',');
        setLoading(true);
        globalGetService(getInvoiceAuthUrl({ invoice_id: invoiceIds })).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                setGlobalCookie('thirdPartyInvoiceState', 'SyncInvoiceFromQB');
                window.open(response.data.data.url, '_blank');
            }
        });
    };

    const syncFromQb = () => {
        setLoading(true);
        globalGetService(getInvoiceAuthUrl()).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                setGlobalCookie('thirdPartyInvoicePullState', 'SyncInvoicePullFromQB');
                window.open(response.data.data.url, '_blank');
            }
        });
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Lease Invoices`, page_type: page_type, })
    }
    
    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
                <LeasesNav />
                {leaseBasicDetails?.status === "Draft" ? (<ModuleNotExcessModal moduleName="Invoices" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
                <div className='lease-details-content lease-inv-contet'>
                    <Grid sx={{marginBottom: '15px !important'}}>
                        <LeaseInvHeaderCards ref={headerCardRef} />
                    </Grid>
                    <Paper square className="responsive-paper">
                            <Grid container spacing={0.5} className="responsive-grid" alignItems='end' sx={{ justifyContent: 'space-between', placeItems: "flex-start", alignItems: 'center' }}>
                                <Grid item size={{ md: 12, xs: 12 }} sx={{mb:-1, marginLeft: "3px"}} className="menu-container lease-list-link-mt">
                                    <BackToLeaseList />
                                </Grid>
                                <Grid size='grow' sx={{ minWidth: 0, overflow: 'hidden' }}>
                                    {!skeletonLoader ? <Box display="flex" alignItems="center"  gap={1} sx={{marginTop:'6px', marginLeft: "-2px" }} flexShrink={0}><FilterComponent filter={filter} filterMenu={invoiceFilterMenu} getResponseBack={onApplyFilter} /></Box> : null}
                                </Grid>
                            <Grid md={8} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <ul className='list-inline lease-details-right-items' style={{padding:'0px', float: 'right' }}>
                                    <li className='lease-mobile-button revision-history'>
                                        <ModuleWiseRevisionHistory  ViewGlobalHistory={() => {setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} }); handleItemClicked('Global Revision HistoryIcon')}} />
                                    </li>
                                    {isQbEnabled && invoicesInfo?.list?.length > 0 && (
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                            <li className='lease-mobile-button'>
                                                <Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { syncFromQb(); handleItemClicked('Sync from QB Button') }}>Sync from QB</Button>
                                            </li>
                                            <li className='lease-mobile-button'>
                                                <Button variant="contained" color="primary" size='small' className='btn-primary' disabled={sentInvoicesForSync.length === 0} onClick={() => { syncInvoicesToQb(); handleItemClicked('Sync to QB Button') }}>Sync to QB ({sentInvoicesForSync.length})</Button>
                                            </li>
                                        </PermissionWrapper>
                                    )}
                                    {invoicesInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <ExportFileTypeComp handelExport={handleExport} isLoading={isExport} isOnlyExcel={true} /></li> : null}
                                    {selectedInvoices.length > 0 &&
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                            <li className='lease-mobile-button' style={{ marginRight: '5px' }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    color="secondary"
                                                    onClick={() => { setBulkChangeStatus({ modal: true }); handleItemClicked('Bulk Change Status') }}
                                                >
                                                    Bulk Change Status ({selectedInvoices.length})
                                                </Button>
                                            </li>
                                        </PermissionWrapper>
                                    }
                                    {canBulkDelete &&
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['D'] }}>
                                            <li className='lease-mobile-button' style={{ marginRight: '5px' }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    color="error"
                                                    onClick={() => { setBulkDeleteInvoices({ modal: true }); handleItemClicked('Bulk Delete Invoice') }}
                                                >
                                                    Bulk Delete ({selectedInvoices.length})
                                                </Button>
                                            </li>
                                        </PermissionWrapper>
                                    }
                                    {canBulkSend &&
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                            <li className='lease-mobile-button' style={{ marginRight: '5px' }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    color="primary"
                                                    onClick={() => { setBulkSendMail({ modal: true }); handleItemClicked('Bulk Invoice Send') }}
                                                >
                                                    Bulk Send Invoice ({selectedInvoices.length})
                                                </Button>
                                            </li>
                                        </PermissionWrapper>
                                    }
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['C'] }}>
                                    <li className="list-inline-item">
                                        <PopOverCTA btnText={`Add Invoice`} btnDisabled = {skeletonLoader} varientText={'contained'} onCloseItem={true}>
                                            <>
                                                <MenuItem onClick={() => { setAddRentalInvoice({ modal: true, data: { ...addInvoiceObj, invoice_type: { label: 'Rental', value: 2 } }, mode: 'add', type: 'rental' }); handleItemClicked('Add Rental Invoice') }}>Rental Invoice</MenuItem>
                                                <MenuItem onClick={() => { setAddEditInvoice({ modal: true, data: { ...addInvoiceObj, invoice_type: { label: 'Ad Hoc Invoice', value: 9 } }, mode: 'add', type: 'adhoc' }); handleItemClicked('Add Adhoc Invoice')}}>Adhoc Invoice</MenuItem>
                                                <MenuItem onClick={() => { setAddCreditDebitNote({ modal: true, data: { ...addInvoiceObj, invoice_type: { label: 'Credit Note', value: 5 } }, mode: 'add', type: 'credit' }); handleItemClicked('Add Credit Note')}}>Credit Note</MenuItem>
                                                <MenuItem onClick={() => { setAddCreditDebitNote({ modal: true, data: { ...addInvoiceObj, invoice_type: { label: 'Debit Note', value: 4  } }, mode: 'add', type: 'debit' }); handleItemClicked('Add Debit Note')}}>Debit Note</MenuItem>
                                            </>
                                        </PopOverCTA>
                                    </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table' style={{ marginTop: '0px' }} elevation={2} square>
                        {skeletonLoader ? <STableLoader count={6} rowCount={8}/> :
                            <div className="table-container lease-inv-table" style={invoicesInfo?.list?.length > 0
                                ? { height: "calc(100vh - 415px)", maxHeight: "none", overflow: "auto", boxSizing: 'border-box' }
                                : { height: "auto", maxHeight: "calc(100vh - 415px)", overflow: "auto", boxSizing: 'border-box' }
                            }>
                                <Table className="mui-table-format" stickyHeader>
                                    <InvoiceHd
                                        sortInfo={sortInfo}
                                        createSortHandler={createSortHandler}
                                        bulkFlag={invoicesInfo?.list?.length > 0 ? invoicesInfo?.list?.length === deleteInvoices?.data?.ids?.length : false}
                                        selectedCount={selectedInCurrentPage.length}
                                        selectableCount={selectableInCurrentPage.length}
                                        onSelectAll={onSelectAll}
                                        hasAnySelection={selectedInvoices.length > 0}
                                    />
                                    <TableBody>
                                        {invoicesInfo?.list?.length > 0 && invoicesInfo?.list?.map((item, index) => {
                                            const uploadedFileData = getApiResponse("invoices", item?.slug);
                                            return (
                                                <InvoiceList
                                                    key={index}
                                                    item={item}
                                                    type={'leaseInvoice'}
                                                    onDelete={(e) => setDeleteInvoices({ modal: true, data: item })}
                                                    viewFile={() => setUploadAttachments({ modal: true, data: item })}
                                                    viewFileStatus={() => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                    onView={() => {
                                                        sessionStorage.setItem("invoiceViewFrom", "viewFromLease");
                                                        if (item?.invoice_type?.value === 10) {
                                                            sessionStorage.setItem("mgmtFeeLeaseSlug", leaseSlug);
                                                        }
                                                        window.open(`/invoices/view/${item?.slug}`, "_blank");
                                                    }}
                                                    viewFrom={() => {
                                                        sessionStorage.setItem("invoiceViewFrom", "viewFromLease");
                                                        if (item?.invoice_type?.value === 10) {
                                                            sessionStorage.setItem("mgmtFeeLeaseSlug", leaseSlug);
                                                        }
                                                    }}
                                                    // onView={() => navigate(`/invoices/view/${item?.slug}`, { state: { from: 'viewFromLease' } })}
                                                    // onEdit={() => navigate(`/invoices/edit/${item?.slug}`, { state: { from: 'edit' } })}
                                                    onInvStatus={() => setChangeInvStatus({ modal: true, data: item })}
                                                    onRevertStatus={() => setRevertStatusInv({ modal: true, data: item })}
                                                    viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                    canSelect={canSelectInvoice(item)}
                                                    selectDisabledReason={getSelectDisabledReason(item)}
                                                    isSelected={selectedInvoices.some(s => s.slug === item.slug)}
                                                    onToggleSelect={() => onToggleSelectInvoice(item)}
                                                    slug={slug?.slug}
                                                />
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        }
                        {!skeletonLoader && invoicesInfo?.list?.length === 0 ? <NoRecordFound /> : null}
                        <Paper>
                            <Pagination
                                pagination={invoicesInfo?.pagination}
                                onPageChange={(event, newPage) => { setSelectedInvoices([]); getInvoices('', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: newPage + 1, per_page: invoicesInfo?.pagination?.per_page, lease_slug: params?.leaseSlug }); }}
                                onRowsPerPageChange={(e) => { setSelectedInvoices([]); getInvoices('', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: 1, per_page: e.target.value, lease_slug: params?.leaseSlug }); }}
                            />
                        </Paper>
                    </Paper>
                </div>}
            </Paper>
            {changeInvStatus.modal ?
                <ChangeInvoiceStatus
                    invoiceStatus={changeInvStatus}
                    invoiceType={changeInvStatus?.data?.invoice_type?.label}
                    offsetInvoice={changeInvStatus?.data?.offset_invoice}
                    onToggleModal={() => setChangeInvStatus({ modal: false, data: {} })}
                    getResponseBack={() => { setSelectedInvoices([]); getInvoices('', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug, }); headerCardRef.current?.refresh(); }}
                /> : null
            }
            {bulkChangeStatus.modal ?
                <BulkChangeInvoiceStatus
                    selectedInvoices={selectedInvoices}
                    onClose={() => setBulkChangeStatus({ modal: false })}
                    getResponseBack={() => {
                        setSelectedInvoices([]);
                        getInvoices('', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug, }); headerCardRef.current?.refresh(); 
                    }}
                /> : null
            }
            {bulkDeleteInvoices.modal ?
                <BulkDeleteInvoiceModal
                    selectedInvoices={selectedInvoices}
                    params={params}
                    pageTitle="Lease Invoices"
                    onClose={() => setBulkDeleteInvoices({ modal: false })}
                    getResponseBack={() => {
                        setSelectedInvoices([]);
                        getInvoices('', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug, }); headerCardRef.current?.refresh();
                    }}
                /> : null
            }
            {bulkSendMail.modal ?
                <BulkSendMailModal
                    selectedInvoices={selectedInvoices}
                    onClose={() => setBulkSendMail({ modal: false })}
                    onSuccess={() => setSelectedInvoices([])}
                    getResponseBack={() => {
                        setSelectedInvoices([]);
                        getInvoices('', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug, }); headerCardRef.current?.refresh();
                    }}
                /> : null
            }
            {addEditInvoice.modal ?
                <AddAdhocInv
                    addEditInvoice={addEditInvoice}
                    leaseSlug={leaseSlug}
                    getResponseBack={() => getInvoices('pageLoader', { page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 })}
                    onToggleModal={() => setAddEditInvoice({ modal: false, mode: '', data: null })}
                /> : null}
            {addRentalInvoice.modal ?
                <AddRentalInv
                    leaseSlug={leaseSlug}
                    getResponseBack={() => getInvoices('pageLoader', { page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 })}
                    onToggleModal={() => setAddRentalInvoice({ modal: false, mode: '', data: null })}
                /> : null}
            {addCreditDebitNote.modal ?
                <AddLeaseCreditDebitNote
                    addEditInvoice={addCreditDebitNote}
                    leaseSlug={leaseSlug}
                    getResponseBack={() => getInvoices('pageLoader', { page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 })}
                    onToggleModal={() => setAddCreditDebitNote({ modal: false, mode: '', data: null })}
                /> : null}
            {deleteInvoices.modal ?
                <DeletePopUp
                    modal={deleteInvoices.modal}
                    title={'Delete Invoice'}
                    onDeleteRecords={() => onDeleteInvoice()}
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteInvoices({ modal: false, data: null })}
                /> : null}
            {revertStatusInv.modal ?
                <RevertInvoiceStatus
                    revertStatusInv={revertStatusInv}
                    onToggleModal={() => setRevertStatusInv({ modal: false, data: null })}
                    getResponseBack={() => { setSelectedInvoices([]) ; getInvoices('', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug, }); headerCardRef.current?.refresh(); }}
                /> : null}
            {uploadAttachments.modal ? <UploadAttachmentsModal
                uploadAttachments={uploadAttachments}
                onToggleModal={() => setUploadAttachments({ modal: false, data: null })}
                invSlug={(slug) => setSlug({ slug: slug })}
                onAttachmentDeleted={onDeteAttchments}
                progressData={(data)=> setUploadFileProgressData(data)}
                getResponseBack={() => { getInvoices('', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50, lease_slug: params?.leaseSlug, })}}
            /> : null}
            {uploadFileStatus?.modal ? <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug(null)}
            /> : null}
            {isLoading ? <PageLoader /> : null}
            {revisionHistory.modal &&
                <RevisionHistory moduleName={"invoices"} revisionHistory={revisionHistory} onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })} />
            }
        </>
    )
}

export default RoleBaseAccess(LeaseInvoices, { application: 'lease_revamp', feature: 'invoices', operationType: ['R'], leaseNav: true });
